// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jknbrmgwzizdtvtnufwb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImprbmJybWd3eml6ZHR2dG51ZndiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY0MzU2NDksImV4cCI6MjA1MjAxMTY0OX0.RY3iYHBuiIjY2bYh9FWJoBCBEBe8SYtOTYAl921Ekdk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);